import script from "./CSelectOption.vue?vue&type=script&lang=ts&setup=true"
export * from "./CSelectOption.vue?vue&type=script&lang=ts&setup=true"

import "./CSelectOption.vue?vue&type=style&index=0&id=af20b9a6&lang=scss"

const __exports__ = script;

export default __exports__